
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/popular",
      function () {
        return require("private-next-pages/articles/popular/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/popular"])
      });
    }
  